import * as React from 'react';
import { createContext, useState } from 'react';
import { MandatoryChildren } from '../models/children-props';
import { PostQueueCountResult } from '../models/graphql';

// Setting a defaultQueueCount, so we can ensure we always reference a valid object
const defaultQueueCount: PostQueueCountResult = {
  categories: [],
  socialProfiles: [],
  status: {
    __typename: 'PostQueueCountStatus',
    scheduled: 0,
    past: 0,
    failed: 0,
    paused: 0,
    draft: 0,
    unqueued: 0,
    deleted: 0
  },
  content: {
    __typename: 'PostQueueCountContent',
    image: 0,
    imageLink: 0,
    link: 0,
    text: 0,
    video: 0,
    videoLink: 0
  },
  timing: {
    __typename: 'PostQueueCountTiming',
    setDates: 0,
    recurring: 0,
    queued: 0
  },
  evergreen: {
    evergreenOnly: 0
  },
  source: {
    __typename: 'PostQueueCountSource',
    autoRss: 0,
    csvUpload: 0,
    postEditor: 0,
    socialImport: 0
  }
};

type QueueCountValueType = {
  queueCounts: PostQueueCountResult;
  setQueueCounts: React.Dispatch<React.SetStateAction<PostQueueCountResult>>;
};

export type QueueCountProviderProps = MandatoryChildren & {
  // ....
};

export const QueueCountContext = createContext<QueueCountValueType>({
  queueCounts: defaultQueueCount,
  setQueueCounts: () => {
    // ..
  }
});

export const QueueCountProvider = (props: QueueCountProviderProps): JSX.Element => {
  const { children } = props;

  const [queueCounts, setQueueCounts] = useState<PostQueueCountResult>(defaultQueueCount);

  return <QueueCountContext.Provider value={{ queueCounts, setQueueCounts }}>{children}</QueueCountContext.Provider>;
};
